<template>
  <div class="layout">
    <emsBreadcrumb :data="breadcrumb" />
    <div class="layout-container">
      <emsTitle
        size="18"
        color="#222"
        bold
        line
      >
        {{ title }}
        <slot
          slot="right"
          name="title-right"
        />
      </emsTitle>
      <div class="layout-container-box">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import emsTitle from '@/component/base/emsTitle'
import emsBreadcrumb from '@/component/emsBreadcrumb.vue'
export default {
  components: {
    emsTitle,
    emsBreadcrumb
  },
  props: {
    breadcrumb: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "'"
    }
  }
}
</script>

<style lang="less" scoped>
@red: #d10100;
@blue: #4466ad;
.layout {
  &-container {
    margin-top: 20px;
    background: #fff;
    &-box {
      padding: 30px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/component/base/layout.vue